export const mPalliativeStudy = {
  "success": true,
  "code": 0,
  "locale": "ca",
  "message": "OK",
  "data": {
    "0": {
      "id": 98,
      "title": "IPOS",
      "description": "Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu",
      "full_title": "Lorem ipsum dolor sit amet, consectetur adipiscing, Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor",
      "master": 1,
      "number_of_participants": 3,
      "number_of_responses": 3,
      "privacity": true,
      "fields": [
        {
          "id": 911,
          "type": 3,
          "title": "POS 1. Rate your pain during the last 3 days",
          "subtitle": "0 = No pain at all, 1 = Slight pain, 2 = Moderate pain, 3 = Severe pain (interferes with activities of daily life), 4 = Very severe pain, 5 = Overwhelming. The worst pain you can imagine",
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 911,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 911,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 911,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 911,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 911,
              "value": 4,
              "text": "4 "
            },
            {
              "field_id": 911,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_pain",
          "visible": true,
          "retrieve_data_type": 0
        }
      ],
      "show_description": null,
      "show_image_url": null
    },
    "1": {
      "id": 108,
      "title": "IPOS_2",
      "full_title": "Lorem ipsum dolor sit amet, consectetur adipiscing",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu",
      "master": 0,
      "number_of_participants": 3,
      "number_of_responses": 7,
      "privacity": false,
      "fields": [
        {
          "id": 922,
          "type": 1,
          "title": "Below is a list of symptoms, which you may or may not have experienced.  For each symptom, please tick one box that best describes how it has affected you over the past 3 days.",
          "subtitle": "For each symptom rate it on a scale of 0-5   0 = No symptom at all, 1 = Slight symptom, 2 = Moderate symptom,  3 = Severe symptom (interferes with activities of daily life),  4 = Very severe symptom,  5 = Overwhelming. The worst symptom you can imagine.",
          "mandatory": 1,
          "answer": -9999,
          "values": [],
          "min_value": null,
          "max_value": null,
          "step_value": null,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_2",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 923,
          "type": 3,
          "title": "POS 2. (a) Shortness of breath",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 923,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 923,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 923,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 923,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 923,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 923,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_breathshortness",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 925,
          "type": 3,
          "title": "POS 2. (b) Weakness or lack of energy",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 925,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 925,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 925,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 925,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 925,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 925,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_weaknesslackenergy",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 926,
          "type": 3,
          "title": "POS 2. (c) Nausea (feeling like you are going to be sick)",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 926,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 926,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 926,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 926,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 926,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 926,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_nausea",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 927,
          "type": 3,
          "title": "POS 2. (d) Vomiting (being sick)",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 927,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 927,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 927,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 927,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 927,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 927,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_vomiting",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 928,
          "type": 3,
          "title": "POS 2. (e) Poor appetite",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 928,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 928,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 928,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 928,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 928,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 928,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_poorappetite",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 929,
          "type": 3,
          "title": "POS 2. (f) Constipation",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 929,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 929,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 929,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 929,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 929,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 929,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_constipation",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 930,
          "type": 3,
          "title": "POS 2. (g) Sore or dry mouth",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 930,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 930,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 930,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 930,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 930,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 930,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_sore",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 931,
          "type": 3,
          "title": "POS 2. (h) Drowsiness",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 931,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 931,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 931,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 931,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 931,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 931,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_drowsiness",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 932,
          "type": 3,
          "title": "POS 2. (i) Poor mobility",
          "subtitle": null,
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 932,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 932,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 932,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 932,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 932,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 932,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_poormobility",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 942,
          "type": 1,
          "title": "If you have more than three symptoms not specified above, choose the most relevant three.",
          "subtitle": null,
          "mandatory": 0,
          "answer": -9999,
          "values": [],
          "min_value": null,
          "max_value": null,
          "step_value": null,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_2_other",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 939,
          "type": 2,
          "title": "POS 2. (k) Specify  symptom 1",
          "subtitle": null,
          "mandatory": 0,
          "answer": -9999,
          "values": [],
          "min_value": null,
          "max_value": null,
          "step_value": null,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_othersymptoms_a",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 934,
          "type": 3,
          "title": "POS 2. (l) Intensity of symptom 1",
          "subtitle": null,
          "mandatory": 0,
          "answer": -9999,
          "values": [
            {
              "field_id": 934,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 934,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 934,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 934,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 934,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 934,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_othersymptoms_1",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 940,
          "type": 2,
          "title": "POS 2. (m) Specify symptom 2",
          "subtitle": null,
          "mandatory": 0,
          "answer": -9999,
          "values": [],
          "min_value": null,
          "max_value": null,
          "step_value": null,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_othersymptoms_b",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 937,
          "type": 3,
          "title": "POS 2. (n) Intensity of symptom 2",
          "subtitle": null,
          "mandatory": 0,
          "answer": -9999,
          "values": [
            {
              "field_id": 937,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 937,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 937,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 937,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 937,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 937,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_othersymptoms_2",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 941,
          "type": 2,
          "title": "POS 2. (o) Specify symptom 3",
          "subtitle": null,
          "mandatory": 0,
          "answer": -9999,
          "values": [],
          "min_value": null,
          "max_value": null,
          "step_value": null,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_othersymptoms_c",
          "visible": true,
          "retrieve_data_type": 0
        },
        {
          "id": 938,
          "type": 3,
          "title": "POS 2. (p) Intensity of symptom 3",
          "subtitle": null,
          "mandatory": 0,
          "answer": -9999,
          "values": [
            {
              "field_id": 938,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 938,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 938,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 938,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 938,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 938,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_othersymptoms_3",
          "visible": true,
          "retrieve_data_type": 0
        }
      ],
      "show_description": null,
      "show_image_url": null
    },
    "2": {
      "id": 109,
      "title": "POS_3",
      "description": "Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu",
      "full_title": "Lorem ipsum dolor sit amet, consectetur adipiscing, Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor",
      "master": 0,
      "number_of_participants": 3,
      "number_of_responses": 7,
      "privacity": true,
      "fields": [
        {
          "id": 913,
          "type": 3,
          "title": "POS 3. Have you been feeling worried about your illness in the past 3 days?",
          "subtitle": "0 = Not at all worried, 1 = Worried very occasionally, 2 = Worried some of time, 3 = Worried a lot of the time, 4 = Worried most of the time, 5 = Worried all of the time",
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 913,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 913,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 913,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 913,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 913,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 913,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_concern",
          "visible": true,
          "retrieve_data_type": 0
        }
      ],
      "show_description": null,
      "show_image_url": null
    },
    "3": {
      "id": 114,
      "title": "POS_4",
      "full_title": "Lorem ipsum dolor sit amet, consectetur adipiscing",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu",
      "master": 0,
      "number_of_participants": 3,
      "number_of_responses": 4,
      "privacity": false,
      "fields": [
        {
          "id": 915,
          "type": 3,
          "title": "POS 4. Over the past 3 days, have you been able to share how you are feeling with your family or friends?",
          "subtitle": "0 = Not at all, 1 = Only once, 2 = Occasionally, 3 = Fairly frequently, 4 = Often, 5 = Yes, I’ve talked freely",
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 915,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 915,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 915,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 915,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 915,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 915,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_feelings",
          "visible": true,
          "retrieve_data_type": 0
        }
      ],
      "show_description": null,
      "show_image_url": null
    },
    "4": {
      "id": 117,
      "title": "POS_5",
      "description": "Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu",
      "full_title": "Lorem ipsum dolor sit amet, consectetur adipiscing, Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor",
      "master": 0,
      "number_of_participants": 3,
      "number_of_responses": 22,
      "privacity": true,
      "fields": [
        {
          "id": 917,
          "type": 3,
          "title": "POS 5. Over the past 3 days, have you felt that life was worthwhile?",
          "subtitle": "0 = Not at all, 1 = Not very often, 2 = Occasionally, 3 = Some of the time, 4 = Most of the time, 5 = Yes, all the time",
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 917,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 917,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 917,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 917,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 917,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 917,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_lifeworthwhile",
          "visible": true,
          "retrieve_data_type": 0
        }
      ],
      "show_description": null,
      "show_image_url": null
    },
    "5": {
      "id": 118,
      "title": "POS_6",
      "full_title": "Lorem ipsum dolor sit amet, consectetur adipiscing",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu",
      "master": 0,
      "number_of_participants": 3,
      "number_of_responses": 1,
      "privacity": false,
      "fields": [
        {
          "id": 919,
          "type": 3,
          "title": "POS 6. Over the past 3 days, have you felt at peace?",
          "subtitle": "0 = Not at all, 1 = Not very often, 2 = Occasionally, 3 = Some of the time, 4 = Most of the time, 5 = Yes, all the time",
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 919,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 919,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 919,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 919,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 919,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 919,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_peacefeeling",
          "visible": true,
          "retrieve_data_type": 0
        }
      ],
      "show_description": null,
      "show_image_url": null
    },
    "6": {
      "id": 119,
      "title": "POS_7",
      "description": "Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu",
      "full_title": " ametLorem ipsum dolor sit ametLorem ",
      "master": 0,
      "number_of_participants": 3,
      "number_of_responses": 0,
      "privacity": true,
      "fields": [
        {
          "id": 920,
          "type": 3,
          "title": "POS 7. Have you had enough help and advice for your family to plan for the future?",
          "subtitle": "0 = None, 1 = Very little, 2 = For a few things, 3 = For several things, 4 = For most things, 5 = As much as wanted",
          "mandatory": 1,
          "answer": -9999,
          "values": [
            {
              "field_id": 920,
              "value": 0,
              "text": "0"
            },
            {
              "field_id": 920,
              "value": 1,
              "text": "1"
            },
            {
              "field_id": 920,
              "value": 2,
              "text": "2"
            },
            {
              "field_id": 920,
              "value": 3,
              "text": "3"
            },
            {
              "field_id": 920,
              "value": 4,
              "text": "4"
            },
            {
              "field_id": 920,
              "value": 5,
              "text": "5"
            }
          ],
          "min_value": 0,
          "max_value": 5,
          "step_value": 1,
          "sufix": "",
          "visibility": true,
          "internal_code": "pos_help",
          "visible": true,
          "retrieve_data_type": 0
        }
      ],
      "show_description": null,
      "show_image_url": null
    }
  }
};
